// shared layout values for the quiz feedback column transition, used by both
// the 360 timeline and the 3D storyboard wiring
export const QUIZ_FEEDBACK_TRANSITION =
  "width 0.08s ease-in-out, min-width 0.08s ease-in-out";

export const QUIZ_FEEDBACK_RAIL_WIDTH = 32;
export const QUIZ_FEEDBACK_FULL_COLUMN_WIDTH = 250;

// while feedback is open, the takes/storyboard column collapses to the rail
// and the two remaining columns split the freed space equally, keeping the
// total width unchanged: rail + 2 * split = 2 * full
export const QUIZ_FEEDBACK_SPLIT_COLUMN_WIDTH =
  QUIZ_FEEDBACK_FULL_COLUMN_WIDTH - QUIZ_FEEDBACK_RAIL_WIDTH / 2;
